export const DRIVER_LICENSE_CATEGORIES = [
  "A",
  "A1",
  "B",
  "B1",
  "C",
  "C1",
  "D",
  "D1",
  "BE",
  "CE",
  "C1E",
  "DE",
  "D1E",
  "M",
  "Tm",
  "Tb",
];
